import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vue-ydui/dist/ydui.rem.css';
import 'vue-ydui/dist/ydui.base.css';
import { ActionSheet } from 'vue-ydui/dist/lib.rem/actionsheet';
import { Button, ButtonGroup } from 'vue-ydui/dist/lib.rem/button';

import {
  Tab,
  TabPanel
} from 'vue-ydui/dist/lib.rem/tab';
Vue.component(Tab.name, Tab);
Vue.component(TabPanel.name, TabPanel);
Vue.component(ActionSheet.name, ActionSheet);
Vue.component(Button.name, Button);
Vue.component(ButtonGroup.name, ButtonGroup);



import {Accordion, AccordionItem} from 'vue-ydui/dist/lib.rem/accordion';
Vue.component(Accordion.name, Accordion);
Vue.component(AccordionItem.name, AccordionItem);

// import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()



import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)



import Axios from 'axios'


Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/apis' : 'https://zhenquan.zeego2.cc'    //正式
Vue.prototype.$CShttp = 'https://zhenquan.zeego2.cc'
Vue.prototype.$ZChttp = 'https://zqconsumer.zeego2.cc/Sign/index.html'                          //注册页面
Vue.prototype.$Loginhttp = 'https://zqconsumer.zeego2.cc'                          //授权跳转页面


// Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/apis' : 'http://zhenquantest.zeego2.cc'   //测试
// Vue.prototype.$CShttp = 'http://zhenquantest.zeego2.cc'
// Vue.prototype.$ZChttp = 'http://zqconsumertest.zeego2.cc/Sign/indexCS.html'                          //注册页面
// import Vconsole from 'vconsole';
// new Vconsole(); 



Vue.prototype.$http = Axios

import animate from 'animate.css'


import * as fundebug from "fundebug-javascript";
import fundebugVue from "fundebug-vue";
fundebug.apikey = "3cb4f7627805b5f2e232c239ef61ec99b95a33d3d77f301d7ea9bc3750ffd2c4"
fundebugVue(fundebug, Vue);

Vue.use(animate)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')